import { useCallback, useRef } from 'react';

interface IProps {
  caption?: string;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick: () => void;
}

const Button = ({ caption, className, disabled, onClick, type }: IProps): JSX.Element => {
  const btnRef = useRef<HTMLButtonElement>(null);

  const handleClick = useCallback(() => onClick(), [onClick]);

  return (
    <button ref={btnRef} type={type} className={className} disabled={disabled} onClick={handleClick}>
      {caption ?? ''}
    </button>
  );
};

export default Button;